/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ClabeEntryRequest} from '@cash-web/protos/squareup/franklin/app/clabe.pb'
import {ClabeEntryResponse} from '@cash-web/protos/squareup/franklin/app/clabe.pb'


export const submitClabeEntry = (request: ClabeEntryRequest, options?: CashRequestOptions) => post<ClabeEntryRequest, ClabeEntryResponse>("/2.0/cash/submit-clabe-entry", request, {...options, rejectOnError: true })